import { FC, useState } from 'react';

import classNames from 'classnames';

import { Product } from '@/types';
import { Badge, Collapse, Icon, Link } from '@/components';
import { getFeelingIconName } from 'utils/treez';
import { PAGE_ROUTES, PRODUCT_FILTER_ATTRIBUTES } from '@/constants';

interface IProductExtraDescriptionsProps {
  product: Product;
}

const ProductExtraDescriptions: FC<IProductExtraDescriptionsProps> = ({
  product,
}) => {
  const [isGeneralOpen, setIsGeneralOpen] = useState(true);
  const [isFlavorsOpen, setIsFlavorsOpen] = useState(true);
  const [isEffectsOpen, setIsEffectsOpen] = useState(true);
  const [isIngredientsOpen, setIsIngredientsOpen] = useState(true);

  const toggleGenerals = () => {
    setIsGeneralOpen(!isGeneralOpen);
  };
  const toggleFlavors = () => {
    setIsFlavorsOpen(!isFlavorsOpen);
  };
  const toggleEffects = () => {
    setIsEffectsOpen(!isEffectsOpen);
  };
  const toggleIngredients = () => {
    setIsIngredientsOpen(!isIngredientsOpen);
  };

  return (
    <>
      {product.flavors && product.flavors.length > 0 && (
        <>
          <button
            aria-controls="accordion-content-iFlavors"
            className="bottom__warning"
            onClick={() => toggleFlavors()}
          >
            <p className={classNames('details__h3', 'extra_details__subtitle')}>
              Flavors
            </p>
            <Icon
              aria-label={isFlavorsOpen ? 'Collapse content' : 'Expand content'}
              name={isFlavorsOpen ? 'angle-up' : 'angle-down'}
            />
          </button>
          <Collapse
            className={classNames('accordion__content', {
              ['accordion__content_collapse']: isFlavorsOpen,
            })}
            id="accordion-content-iFlavors"
            isOpen={isFlavorsOpen}
          >
            <div className="extra__content">
              {product.flavors.map(flavor => (
                <Link
                  aria-label="Go to shop"
                  href={`${PAGE_ROUTES.SHOP}?${PRODUCT_FILTER_ATTRIBUTES._FLAVORS}=${flavor}`}
                  key={flavor}
                >
                  <Badge className="extra_details__badge">
                    <span>{flavor}</span>
                  </Badge>
                </Link>
              ))}
            </div>
          </Collapse>
        </>
      )}

      {product.effects && product.effects.length > 0 && (
        <>
          <button
            aria-controls="accordion-content-iEffects"
            className="bottom__warning"
            onClick={() => toggleEffects()}
          >
            <p className={classNames('details__h3', 'extra_details__subtitle')}>
              Effects
            </p>
            <Icon
              aria-label={isEffectsOpen ? 'Collapse content' : 'Expand content'}
              name={isEffectsOpen ? 'angle-up' : 'angle-down'}
            />
          </button>
          <Collapse
            className={classNames('accordion__content', {
              ['accordion__content_collapse']: isEffectsOpen,
            })}
            id="accordion-content-iEffects"
            isOpen={isEffectsOpen}
          >
            <div className={'extra__content'}>
              {product.effects.map(effect => (
                <Link
                  aria-label="Go to shop"
                  href={`${PAGE_ROUTES.SHOP}?${PRODUCT_FILTER_ATTRIBUTES._EFFECTS}=${effect}`}
                  key={effect}
                >
                  <Badge className={'extra_details__badge'}>
                    <Icon
                      className="item_icon"
                      name={getFeelingIconName(effect)}
                    />
                    <span>{effect}</span>
                  </Badge>
                </Link>
              ))}
            </div>
          </Collapse>
        </>
      )}

      {product.generals && product.generals.length > 0 && (
        <>
          <button
            aria-controls="accordion-content-iGeneral"
            className="bottom__warning"
            onClick={() => toggleGenerals()}
          >
            <p className={classNames('details__h3', 'extra_details__subtitle')}>
              General
            </p>
            <Icon
              aria-label={isGeneralOpen ? 'Collapse content' : 'Expand content'}
              name={isGeneralOpen ? 'angle-up' : 'angle-down'}
            />
          </button>
          <Collapse
            className={classNames('accordion__content', {
              ['accordion__content_collapse']: isGeneralOpen,
            })}
            id="accordion-content-iGeneral"
            isOpen={isGeneralOpen}
          >
            <div className={'extra__content'}>
              {product.generals?.map((general: string) => (
                <Link
                  aria-label="Go to shop"
                  href={`${PAGE_ROUTES.SHOP}?${PRODUCT_FILTER_ATTRIBUTES._GENERALS}=${general}`}
                  key={general}
                >
                  <Badge className={'extra_details__badge'}>
                    <span>{general}</span>
                  </Badge>
                </Link>
              ))}
            </div>
          </Collapse>
        </>
      )}
      {product.ingredients && product.ingredients.length > 0 && (
        <>
          <button
            aria-controls="accordion-content-iIngredients"
            className="bottom__warning"
            onClick={() => toggleIngredients()}
          >
            <p className={classNames('details__h3', 'extra_details__subtitle')}>
              Ingredients
            </p>
            <Icon
              aria-label={
                isIngredientsOpen ? 'Collapse content' : 'Expand content'
              }
              name={isIngredientsOpen ? 'angle-up' : 'angle-down'}
            />
          </button>
          <Collapse
            className={classNames('accordion__content', {
              ['accordion__content_collapse']: isIngredientsOpen,
            })}
            id="accordion-content-iIngredients"
            isOpen={isIngredientsOpen}
          >
            <div className={'extra__content'}>
              {product.ingredients?.map((ingredient: string) => (
                <Link
                  aria-label="Go to shop"
                  href={`${PAGE_ROUTES.SHOP}?${PRODUCT_FILTER_ATTRIBUTES._INGREDIENTS}=${ingredient}`}
                  key={ingredient}
                >
                  <Badge className={'extra_details__badge'}>
                    <span>{ingredient}</span>
                  </Badge>
                </Link>
              ))}
            </div>
          </Collapse>
        </>
      )}
    </>
  );
};

export { ProductExtraDescriptions };
